<template>
  <div id="client">
    <router-view> </router-view>
  </div>
</template>

<script>
export default {
  name: 'Client',
  data () {
    return {
     
    }
  },
  components : {
    
  }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/client/index.vue